<script>
  import { Router, Route } from "svelte-routing";
  import { onMount } from 'svelte';
  import data from "./routes";
  import { navigate } from 'svelte-routing';

  import Layout from "./routes/Layout.svelte";
  import Login2 from "./pages/Authentication/Login2.svelte";
  import { user, callUser } from "./services/user.js"; // Import the user store and callUser function

  export let url = "";

  import { addMessages, init } from "svelte-i18n";

  import en from "../public/lang/en.json";

  addMessages("en", en);

  init({
    initialLocale: "en",
  });

  // Check for JWT in localStorage on app load and re-authenticate
  onMount(async () => {
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      await callUser(jwt);
    }
  });
</script>

<Router {url}>
  {#each data.publicRoutes as route}
    <Route path={route.path}>
      <svelte:component this={route.component} />
    </Route>
  {/each}

  {#each data.authProtectedRoutes as route}
    <Route path={route.path} let:params>
      {#if $user}
        <Layout>
          <svelte:component this={route.component} />
        </Layout>
      {:else}
        <svelte:component this={Login2} />
      {/if}
    </Route>
  {/each}
</Router>
